// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"402":"cc6bd574","467":"06465d4e"}[chunkId] + ".chunk.css";
};